/**
 * Web Polyfills
 * Must run BEFORE React Native loads
 * Fixes PlatformConstants.getEnforcing() error
 */

// Polyfill NativeModules.PlatformConstants before React Native loads
if (typeof window !== 'undefined') {
  // Create NativeModules polyfill on window object
  if (!window.__REACT_NATIVE_NATIVE_MODULES_POLYFILL__) {
    window.__REACT_NATIVE_NATIVE_MODULES_POLYFILL__ = {
      PlatformConstants: {
        getEnforcing: () => false,
        enforce: () => false,
        forceTouchAvailable: false,
        interfaceIdiom: 'handset',
        isTesting: false,
        osVersion: '0.0.0',
        systemName: 'Web',
      },
    };
  }
}

// Export for use in webpack
if (typeof module !== 'undefined' && module.exports) {
  module.exports = window.__REACT_NATIVE_NATIVE_MODULES_POLYFILL__;
}






